import React from 'react';
import { useHistory } from 'react-router-dom';
import { CustomInput } from 'reactstrap';
import helper from '../../../../../utils/helper';
import Datagrid from '../../../../UI/Datagrid';

export default ({ t, ...props }) => {
  const history = useHistory();
  const activeFormatter = (cell, row, rowIndex) => (
    <CustomInput
      type="checkbox"
      id={`${row.sensorId}-active-checkbox`}
      checked={cell}
      onChange={(e) => props.onUpdateActive(row.sensorId, e.target.checked)}
    />
  );
  const alertsFormatter = (cell, row, rowIndex) => (
    <CustomInput
      type="checkbox"
      id={`${row.sensorId}-alerts-checkbox`}
      checked={cell}
      onChange={(e) => props.onUpdateAlerts(row.sensorId, e.target.checked)}
    />
  );
  const columns = [
    {
      dataField: 'model',
      text: 'Model',
      sort: true,
      headerStyle: { width: '7%' },
    },
    { dataField: 'serialNo', text: 'Serial Number', sort: true },
    { dataField: 'name', text: 'Name', sort: true },
    { dataField: 'location', text: 'Location', sort: true },
    { dataField: 'typeName', text: 'Type', sort: true },
    { dataField: 'device', text: 'Device', sort: true },
    {
      dataField: 'active',
      text: 'Active',
      formatter: activeFormatter,
      headerStyle: { width: '5%' },
    },
    {
      dataField: 'alerts',
      text: 'Alerts',
      formatter: alertsFormatter,
      headerStyle: { width: '5%' },
    },
  ];
  const defaultSorted = [
    {
      dataField: 'serialNo',
      order: 'asc',
    },
  ];
  const ctxMenuOptions = [
    [
      {
        name: 'Edit sensor',
        className: (row) =>
          helper.checkPermission('Admin') ||
          helper.checkPermission('Group Administrator')
            ? ''
            : 'item-disabled',
        action: (row, rowIndex) => {
          history.push(
            `/configure/groups/edit-sensor?groupId=${props.match.params.groupId}&sensorId=${row.sensorId}`,
          );
        },
      },
    ],
  ];

  const [sensorIds, setSensorIds] = React.useState([]);
  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setSensorIds([...sensorIds, row.sensorId]);
    } else {
      setSensorIds(sensorIds.filter((x) => x !== row.sensorId));
    }
  };
  const handleOnSelectAll = (isSelect, rows) => {
    const ids = rows.map((r) => r.sensorId);
    if (isSelect) {
      setSensorIds((sensorIds) => helper.tableHelper.selectAll(sensorIds, ids));
    } else {
      setSensorIds((sensorIds) =>
        helper.tableHelper.deselectAll(sensorIds, ids),
      );
    }
  };
  const selectRow = {
    mode: 'checkbox',
    selected: sensorIds,
    onSelect: handleOnSelect,
    onSelectAll: handleOnSelectAll,
  };
  React.useEffect(() => {
    props.onSelectAssignedSensors(sensorIds);
  }, [sensorIds]);
  React.useEffect(() => {
    if (props.sensors.isCompleted) {
      setSensorIds([]);
      props.sensorsActions.resetCompleted();
    }
  }, [props.sensors.isCompleted]);
  return (
    <Datagrid
      datagridProps={{
        keyField: 'sensorId',
        data: props.assignedSensors,
        columns,
        selectRow,
        defaultSorted,
      }}
      ctxMenuOptions={ctxMenuOptions}
      exportProps={{
        fileName: 'AssignedList',
      }}
    />
  );
};
